/**
 * 项目档案实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-09
 */

import { useState, useEffect } from 'react';
import {
    theme,
    message,
    Modal,
    Button,
    Timeline,
    Flex,
    Progress,
    Tag,
    Statistic,
    Space,
    Typography,
} from 'antd';
import { generate } from '@ant-design/colors';
import $ from 'jquery';
import { ClockCircleOutlined } from '@ant-design/icons';
import {
    AddRequestHeaders,
    UjoinParams,
    Html2pdf,
    BrandUrl,
    SloganUrl,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const { Text } = Typography;

const twoColors = {
    '0%': '#108ee9',
    '100%': '#87d068',
};

const Entity = (props) => {
    const { open, setOpen, record, preGroup } = props;
    const { token: { fontSize } } = theme.useToken();

    const [messageApi, contextHolder] = message.useMessage();

    const [data, setData] = useState([]);

    const cancel = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (!open) return;

        // 获取项目进度日志
        const params = {
            rss: 'list',
            project_ulid: record.key,
            start_date: '',
            end_date: '',
        };
        $.ajax({
            url: `${CNF.api}projects/progressLogs${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    let newData = [];
                    var initPhase = '';
                    for (let i = 0; i < data.dat.length; i++) {
                        let item = data.dat[i];
                        let obj = {
                            content: <Space size='small' align='start'>
                                <div style={{ width: 90 }}>{item.record_time}: </div>
                                <Tag style={{ width: 52, color: item.node_color, textAlign: 'center' }} size='small' color={generate(item.node_color)[0]}>{item.node_status}</Tag>
                                <Progress style={{ width: 70 }} size='small' percent={item.progress} strokeColor={twoColors} />
                                <Text>{item.description}</Text>
                            </Space>,
                            color: item.node_color,
                        }
                        // 每个阶段打上时间标签
                        if (item.phase !== initPhase) {
                            obj.icon = (
                                <ClockCircleOutlined style={{ fontSize: '16px', }} />
                            )
                            initPhase = item.phase;
                        }
                        newData.push(obj);
                    }
                    setData(newData);
                } else {
                    setData([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        })
    }, [open, record, messageApi]);

    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };

    const download = () => { Html2pdf('print-info-id', record.name + '.' + record.date, false); };


    return <>
        {contextHolder}
        <Modal
            width={820}
            style={{ top: 0 }}
            closable={false}
            open={open}
            keyboard={true}
            onCancel={cancel}
            footer={[
                <Button key='back' onClick={cancel}>取消</Button>,
                <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                <Button key='link' type='primary' onClick={download} style={{ marginRight: 20 }}>下载</Button>,
            ]}
        >
            <div id='print-info-id'>
                <div className='print-info' style={{ padding: '0 30px' }}>
                    <Flex justify='space-between' style={{ marginBottom: '10px' }}>
                        <img src={BrandUrl} height='35px' alt={preGroup || CNF.companyShortName} />
                        <img src={SloganUrl} height='35px' alt={preGroup || CNF.companyShortName} />
                    </Flex>
                    <table width='100%'>
                        <thead align='center'>
                            <tr>
                                <th colSpan='24'><h2>{record.name}</h2></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan='4' style={{ width: 120 }}>项目编号</td><td colSpan='8' style={{ width: 240 }}>{record.number}</td>
                                <td colSpan='4' style={{ width: 120 }}>项目进度</td><td colSpan='8' style={{ width: 240 }}>{record.progress}%</td>
                            </tr>
                            <tr>
                                <td colSpan='4' style={{ width: 120 }}>合同金额</td><td colSpan='8' style={{ width: 240 }}><Tag color='green'><Statistic precision={CNF.DPL} suffix={record.contract_amount > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: 'green' } }} value={record.contract_amount >= 10000 ? record.contract_amount / 10000 : record.contract_amount} /></Tag></td>
                                <td colSpan='4' style={{ width: 120 }}>签订日期</td><td colSpan='8' style={{ width: 240 }}>{record.contract_date}</td>
                            </tr>
                            <tr>
                                <td colSpan='4' style={{ width: 120 }}>项目类型</td><td colSpan='8' style={{ width: 240 }}>{record.type}</td>
                                <td colSpan='4' style={{ width: 120 }}>项目阶段</td><td colSpan='8' style={{ width: 240 }}>{record.phase}</td>
                            </tr>
                            <tr><td colSpan='4' style={{ width: 120 }}>备注:</td><td colSpan='19' style={{ width: 600 }}>
                                {record.description && record.description.split('\n').map((item, index) => {
                                    return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                })}
                            </td></tr>
                        </tbody>
                    </table>
                    <Timeline
                        style={{ marginTop: 20 }}
                        mode='start'
                        items={data}
                    />
                </div>
            </div>
        </Modal>
    </>
}

export default Entity